import { compareTimelineEntries } from '@/lib/messageSlots'
import type { DirectorNote } from '@/types/domain'
import * as notes from '@/features/story-conversation/directorNotes'
export { normalizeVisibilityCount, createBlankDirectorNoteDraft, normalizeDirectorNoteDraft, type DirectorNoteDraft } from '@/features/story-conversation/directorNotes'

export function normalizeDirectorNote(raw: unknown): DirectorNote | null {
  const note = notes.normalizeDirectorNote(raw)
  if (!note) return null
  const record = raw as Record<string, unknown>
  return { ...record, ...note,
    ...(record.id != null ? { id: Number(record.id) } : {}),
    ...(record.message_id != null ? { message_id: Number(record.message_id) } : {}),
  } as DirectorNote
}

type OrderedMessage = NonNullable<Parameters<typeof notes.countLaterUserMessages>[0]>[number]
const ordered = (messages: OrderedMessage[] = []) => [...messages].sort(compareTimelineEntries)
export const countLaterUserMessages = (messages: OrderedMessage[], sourceMessageId: number | string) => notes.countLaterUserMessages(ordered(messages), sourceMessageId)
export const isDirectorNoteActive = (input: Parameters<typeof notes.isDirectorNoteActive>[0]) => notes.isDirectorNoteActive({ ...input, messages: ordered(input.messages) })
export const getDirectorNoteStatus = (input: Parameters<typeof notes.getDirectorNoteStatus>[0]) => notes.getDirectorNoteStatus({ ...input, messages: ordered(input.messages) })
export const buildMessageContentWithDirectorNote = (input: Parameters<typeof notes.buildMessageContentWithDirectorNote>[0]) => notes.buildMessageContentWithDirectorNote({ ...input, messages: ordered(input.messages) })
